var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.color,staticStyle:{"font-weight":"bold","font-size":"1.1rem"}},[_vm._v(_vm._s(_vm.params.data.seoScore))]),_vm._v(" "),(!isNaN(_vm.params.data.seoScore))?_c('span',[_vm._v("/ 100")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }